import { render, staticRenderFns } from "./WeekGrid.vue?vue&type=template&id=8dd4e890&scoped=true"
import script from "./WeekGrid.vue?vue&type=script&lang=js"
export * from "./WeekGrid.vue?vue&type=script&lang=js"
import style0 from "./WeekGrid.vue?vue&type=style&index=0&id=8dd4e890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd4e890",
  null
  
)

export default component.exports